import { createAsyncThunk } from "@reduxjs/toolkit";
import apiInstance from "config/axiosInstance";
import { toast } from "react-toastify";

export const GetAllClaimPolls = createAsyncThunk(
    "claimPolls/GetAllClaimPolls",
    async (body) => {
        try {
            const response = await apiInstance.post("insurance/pollsList", body);
            return response.data;
        } catch (error) {
            toast.error(error.response?.data || "Something went wrong");
        }
    }
);
export const ViewSingleClaimPoll = createAsyncThunk(
    "claimPolls/ViewSingleClaimPoll",
    async (body) => {
        try {
            const response = await apiInstance.post("insurance/pollsView", body);
            return response.data;
        } catch (error) {
            toast.error(error.response?.data || "Something went wrong");
        }
    }
);